import VueBaseController from '../vue_base'

export class IndexController extends VueBaseController {
  static get COMPONENT() { return () => import('@/vue/pages/clients/keyword_clusterings/index.vue') }

  static values = {
    clientId: String
  }

  connect() {
    super.connect({
      clientId: this.clientIdValue
    })
  }
}

export class NewController extends VueBaseController {
  static get COMPONENT() { return () => import('@/vue/pages/clients/keyword_clusterings/new.vue') }

  static values = {
    clientId: String,
    serpApiEnabled: Boolean,
    valueSerpEnabled: Boolean
  }

  connect() {
    super.connect({
      clientId: this.clientIdValue,
      serpApiEnabled: this.serpApiEnabledValue,
      valueSerpEnabled: this.valueSerpEnabledValue
    })
  }
}

export class ShowController extends VueBaseController {
  static get COMPONENT() { return () => import('@/vue/pages/clients/keyword_clusterings/show.vue') }

  static values = {
    clusteringId: String,
    generatingTopicalClusters: Boolean,
    generatedTopicalClusters: Boolean
  }

  connect() {
    super.connect({
      clusteringId: this.clusteringIdValue,
      generatingTopicalClusters: this.generatingTopicalClustersValue,
      generatedTopicalClusters: this.generatedTopicalClustersValue

    })
  }
}
